import { RunStateTransition } from "types/generated";

import ApplyingEntry from "../entries/ApplyingEntry";
import { canShowElement } from "./elements";
import { RunElementType, RunEntryContext } from "../types";
import { getRunStateTransitionId } from "./getRunStateTransitionId";
import { mergeWithAfterRunHooks } from "./mergeWithAfterRunHooks";

export const createApplyingEntry = (
  { timestamp, until, stateVersion, hasLogs }: RunStateTransition,
  {
    runHooks,
    runId,
    stackId,
    isModuleRun,
    canStop,
    isRunFinished,
    runQueryToRefetch,
  }: RunEntryContext
) => {
  let afterHooks = runHooks.afterApply;

  if (isRunFinished && canShowElement(RunElementType.AfterRunHooks)) {
    afterHooks = mergeWithAfterRunHooks(afterHooks, runHooks.afterRun);
  }

  return (
    <ApplyingEntry
      key={getRunStateTransitionId(timestamp, stateVersion)}
      timestamp={timestamp}
      until={until}
      stateVersion={stateVersion}
      hasLogs={hasLogs}
      openLogsByDefault={canShowElement(RunElementType.Logs)}
      showStopButton={canShowElement(RunElementType.TerminateRunAction)}
      beforeHooks={runHooks.beforeApply}
      afterHooks={afterHooks}
      runId={runId}
      stackId={stackId}
      isModuleRun={isModuleRun}
      canStop={canStop}
      runQueryToRefetch={runQueryToRefetch}
    />
  );
};
